import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBars, faColumns, faCopy, faExchangeAlt, faFileArchive, faFileExport, faList, faLock, faPlay, faPlus, faShareAlt, faStream, faTrash, faUserLock, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup, BDropdown, BDropdownDivider, BDropdownItem, BDropdownText, BFormCheckbox, BModal, BSpinner, } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { canMutateHistory } from "@/api";
import { iframeRedirect } from "@/components/plugins/legacyNavigation";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import CopyModal from "@/components/History/Modals/CopyModal.vue";
import SelectorModal from "@/components/History/Modals/SelectorModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryNavigation',
    props: {
        histories: null,
        history: null,
        title: { default: "Histories" },
        historiesLoading: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive, faBars, faColumns, faCopy, faExchangeAlt, faFileArchive, faFileExport, faLock, faPlay, faPlus, faShareAlt, faList, faStream, faTrash, faUserLock);
        const showSwitchModal = ref(false);
        const purgeHistory = ref(false);
        const userStore = useUserStore();
        const historyStore = useHistoryStore();
        const { isAnonymous } = storeToRefs(userStore);
        const { totalHistoryCount } = storeToRefs(historyStore);
        const canEditHistory = computed(() => {
            return canMutateHistory(props.history);
        });
        const historyState = computed(() => {
            if (props.history.purged) {
                return "purged";
            }
            else if (props.history.deleted) {
                return "deleted";
            }
            else if (props.history.archived) {
                return "archived";
            }
            else {
                return "active";
            }
        });
        function onDelete() {
            if (purgeHistory.value) {
                historyStore.deleteHistory(props.history.id, true);
            }
            else {
                historyStore.deleteHistory(props.history.id, false);
            }
        }
        function userTitle(title) {
            if (isAnonymous.value) {
                return localize("Log in to") + " " + localize(title);
            }
            else {
                return localize(title);
            }
        }
        return { __sfc: true, props, showSwitchModal, purgeHistory, userStore, historyStore, isAnonymous, totalHistoryCount, canEditHistory, historyState, onDelete, userTitle, faArchive, faBars, faColumns, faCopy, faExchangeAlt, faFileArchive, faFileExport, faList, faLock, faPlay, faPlus, faShareAlt, faStream, faTrash, faUserLock, FontAwesomeIcon, BButton, BButtonGroup, BDropdown, BDropdownDivider, BDropdownItem, BDropdownText, BFormCheckbox, BModal, BSpinner, iframeRedirect, localize, CopyModal, SelectorModal };
    }
});
